window.mugo||={};const breakpoints={xxs:321,xs:450,sm:768,md:900,lg:1200,xlg:1441,xxlg:1675,xxxlg:1920},cssClasses={active:"is-active",added:"is-added",collapsed:"is-collapsed",disabled:"is-disabled",hidden:"is-hidden",visible:"is-visible",lazyload:"lazyload",lazyloaded:"lazyloaded",loading:"is-loading",removing:"is-removing",sale:"is-sale",sticky:"is-sticky",tabbable:"is-tabbable",utils:{lockOverflow:"util-lock-overflow"}};Object.assign(window.mugo,{breakpoints,cssClasses}),document.addEventListener("DOMContentLoaded",(()=>{const s=navigator.userAgent.indexOf("Chrome")>-1;let e=navigator.userAgent.indexOf("Safari")>-1;e=!s||!e,e&&document.body.classList.add("is-safari")}));
const klaviyoRenameWatcher = setInterval(() => {
  const reviewsTab = document.getElementById("kl_reviews_tabs__reviews_tab");
  if (reviewsTab && reviewsTab.innerText.trim().startsWith("Reviews")) {
    reviewsTab.childNodes[0].textContent = "Testimonials";
    clearInterval(klaviyoRenameWatcher);
  }
}, 300);
const testimonialWatcher = setInterval(() => {
  // Search placeholder
  const searchInput = document.querySelector('input[placeholder="Search reviews"]');
  if (searchInput) {
    searchInput.placeholder = "Search testimonials";
  }

  // "Write a review" button
  const writeButton = [...document.querySelectorAll('button, a')]
    .find(el => el.textContent.trim().toLowerCase() === 'write a review');
  if (writeButton) {
    writeButton.textContent = "Write a testimonial";
  }

  // Tab label (already replaced above, but include for redundancy)
  const tab = document.getElementById("kl_reviews_tabs__reviews_tab");
  if (tab && tab.childNodes[0] && tab.childNodes[0].textContent.trim().toLowerCase() === "reviews") {
    tab.childNodes[0].textContent = "Testimonials";
  }

  // If everything is replaced, stop watching
  if (searchInput && writeButton && tab) {
    clearInterval(testimonialWatcher);
  }
}, 300);

